<template>
  <div>
    <p class="text-sm mb-4">Détail des coûts du devis</p>
    <Table :columns="columns" :data="quotation.costs">
      <template #type="{ row }">
        {{ $t(`claim.cost_type.${row.type}`) }}
      </template>
    </Table>
    <div class="mt-4 flex items-center text-sm">
      <span class="sm">Etat du produit :</span>
      <span class="ml-3">{{ quotation.productState }}</span>
    </div>
  </div>
</template>

<script>
import { Table } from "@estaly/ui";

export default {
  props: ["quotation"],
  components: {
    Table,
  },
  computed: {
    columns() {
      return [
        {
          label: "Type",
          field: "type",
          slot: "type",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "Prix unitaire HT",
          field: "unitPriceBeforeTax",
          price: true,
        },
        {
          label: "Prix unitaire TTC",
          field: "unitPrice",
          price: true,
        },
        {
          label: "Quantité",
          field: "quantity",
          numeric: true,
        },
        {
          label: "Total",
          field: "total",
          price: true,
          bold: true,
        },
      ];
    },
  },
};
</script>
